import Header from "../componetns/inc/Header";
import BackLog from "../componetns/project/BackLog";
import Blocked from "../componetns/project/Blocked";
import Doing from "../componetns/project/Doing";
import Done from "../componetns/project/Done";
import Ready from "../componetns/project/Ready";
import Review from "../componetns/project/Review";
import Logo from "./../assets/images/logo.png";

export default function Projects() {
    return (
        <>
            <div className="flex flex-col w-screen h-screen overflow-auto text-gray-700 bg-gradient-to-tr from-blue-200 via-indigo-200 to-pink-200">
                <Header />
                <div className="px-10 mt-6">
                    <h1 className="text-2xl font-bold">Project Board</h1>
                </div>
                <div className="flex flex-grow px-10 mt-4 space-x-6 overflow-auto">
                    <BackLog />
                    <Ready />
                    <Doing />
                    <Review />
                    <Blocked />
                    <Done />
                </div>
            </div>

            <a
                className="fixed bottom-0 right-0 flex items-center justify-center h-8 pl-1 pr-2 mb-6 mr-4 text-blue-100 bg-indigo-600 rounded-full shadow-lg hover:bg-blue-600"
                href="https://learnwithsumit.com"
                target="_top"
            >
                <div className="flex items-center justify-center w-6 h-6 bg-blue-500 rounded-full">
                    <img src={Logo} alt="LWS Logo" />
                </div>
                <span className="ml-1 text-sm leading-none">
                    Learn with Sumit
                </span>
            </a>
        </>
    );
}
